"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPackageInstanceClientInvoicesInvoiceStatusEnum = exports.PackageInstanceApi = void 0;
const runtime = __importStar(require("../runtime"));
const models_1 = require("../models");
/**
 *
 */
class PackageInstanceApi extends runtime.BaseAPI {
    /**
     * Change a complete package instance to be active again
     */
    async activateCompletedPackageInstanceRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling activateCompletedPackageInstance.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling activateCompletedPackageInstance.');
        }
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling activateCompletedPackageInstance.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling activateCompletedPackageInstance.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/clients/{clientId}/package-instances/{packageInstanceId}/activate`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Change a complete package instance to be active again
     */
    async activateCompletedPackageInstance(requestParameters, initOverrides) {
        const response = await this.activateCompletedPackageInstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Assign package to client
     */
    async assignPackageRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling assignPackage.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling assignPackage.');
        }
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling assignPackage.');
        }
        if (requestParameters.assignPackageRequest === null || requestParameters.assignPackageRequest === undefined) {
            throw new runtime.RequiredError('assignPackageRequest', 'Required parameter requestParameters.assignPackageRequest was null or undefined when calling assignPackage.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/clients/{clientId}/assign-package`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.AssignPackageRequestToJSON)(requestParameters.assignPackageRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.CreateClient200ResponseFromJSON)(jsonValue));
    }
    /**
     * Assign package to client
     */
    async assignPackage(requestParameters, initOverrides) {
        const response = await this.assignPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Book package as a client
     */
    async bookPackageRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling bookPackage.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling bookPackage.');
        }
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling bookPackage.');
        }
        if (requestParameters.bookPackageRequest === null || requestParameters.bookPackageRequest === undefined) {
            throw new runtime.RequiredError('bookPackageRequest', 'Required parameter requestParameters.bookPackageRequest was null or undefined when calling bookPackage.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/clients/{clientId}/book-package`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.BookPackageRequestToJSON)(requestParameters.bookPackageRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.CreateClient200ResponseFromJSON)(jsonValue));
    }
    /**
     * Book package as a client
     */
    async bookPackage(requestParameters, initOverrides) {
        const response = await this.bookPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Return a boolean field indicating if the appointment can be scheduled and the reason why it can or can\'t be scheduled
     * Check if the appointment can be scheduled on a package
     */
    async canScheduleAppointmentOnPackageRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling canScheduleAppointmentOnPackage.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling canScheduleAppointmentOnPackage.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling canScheduleAppointmentOnPackage.');
        }
        if (requestParameters.start === null || requestParameters.start === undefined) {
            throw new runtime.RequiredError('start', 'Required parameter requestParameters.start was null or undefined when calling canScheduleAppointmentOnPackage.');
        }
        if (requestParameters.end === null || requestParameters.end === undefined) {
            throw new runtime.RequiredError('end', 'Required parameter requestParameters.end was null or undefined when calling canScheduleAppointmentOnPackage.');
        }
        const queryParameters = {};
        if (requestParameters.start !== undefined) {
            queryParameters['start'] = requestParameters.start;
        }
        if (requestParameters.end !== undefined) {
            queryParameters['end'] = requestParameters.end;
        }
        if (requestParameters.schedulerId !== undefined) {
            queryParameters['schedulerId'] = requestParameters.schedulerId;
        }
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/package-instances/{packageInstanceId}/can-schedule`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.CanScheduleAppointmentOnPackage200ResponseFromJSON)(jsonValue));
    }
    /**
     * Return a boolean field indicating if the appointment can be scheduled and the reason why it can or can\'t be scheduled
     * Check if the appointment can be scheduled on a package
     */
    async canScheduleAppointmentOnPackage(requestParameters, initOverrides) {
        const response = await this.canScheduleAppointmentOnPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Complete a package instance
     */
    async completePackageInstanceRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling completePackageInstance.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling completePackageInstance.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling completePackageInstance.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/package-instances/{packageInstanceId}/complete`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Complete a package instance
     */
    async completePackageInstance(requestParameters, initOverrides) {
        const response = await this.completePackageInstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create package order (pending package instance to be processed)
     */
    async createPackageOrderRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling createPackageOrder.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling createPackageOrder.');
        }
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling createPackageOrder.');
        }
        if (requestParameters.createPackageOrderRequest === null || requestParameters.createPackageOrderRequest === undefined) {
            throw new runtime.RequiredError('createPackageOrderRequest', 'Required parameter requestParameters.createPackageOrderRequest was null or undefined when calling createPackageOrder.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/clients/{clientId}/package-instances/create-package-order`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.CreatePackageOrderRequestToJSON)(requestParameters.createPackageOrderRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.CreateClient200ResponseFromJSON)(jsonValue));
    }
    /**
     * Create package order (pending package instance to be processed)
     */
    async createPackageOrder(requestParameters, initOverrides) {
        const response = await this.createPackageOrderRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete a package instance
     */
    async deletePackageInstanceRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling deletePackageInstance.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling deletePackageInstance.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling deletePackageInstance.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/package-instances/{packageInstanceId}/delete`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Delete a package instance
     */
    async deletePackageInstance(requestParameters, initOverrides) {
        const response = await this.deletePackageInstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * End package instance
     */
    async endPackageInstanceRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling endPackageInstance.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling endPackageInstance.');
        }
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling endPackageInstance.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling endPackageInstance.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/clients/{clientId}/package-instances/{packageInstanceId}/end`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * End package instance
     */
    async endPackageInstance(requestParameters, initOverrides) {
        const response = await this.endPackageInstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * End package instance preview
     */
    async endPackageInstancePreviewRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling endPackageInstancePreview.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling endPackageInstancePreview.');
        }
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling endPackageInstancePreview.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling endPackageInstancePreview.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/clients/{clientId}/package-instances/{packageInstanceId}/end/preview`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.EndPackageInstancePreview200ResponseFromJSON)(jsonValue));
    }
    /**
     * End package instance preview
     */
    async endPackageInstancePreview(requestParameters, initOverrides) {
        const response = await this.endPackageInstancePreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get package instance card
     */
    async getPackageInstanceCardRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getPackageInstanceCard.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling getPackageInstanceCard.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/package-instances/{packageInstanceId}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.PackageInstanceCardFromJSON)(jsonValue));
    }
    /**
     * Get package instance card
     */
    async getPackageInstanceCard(requestParameters, initOverrides) {
        const response = await this.getPackageInstanceCardRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get all package instance cards
     */
    async getPackageInstanceCardsRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getPackageInstanceCards.');
        }
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling getPackageInstanceCards.');
        }
        const queryParameters = {};
        if (requestParameters.clientParentId !== undefined) {
            queryParameters['clientParentId'] = requestParameters.clientParentId;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/clients/{clientId}/package-instances`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.PackageInstanceCardFromJSON));
    }
    /**
     * Get all package instance cards
     */
    async getPackageInstanceCards(requestParameters, initOverrides) {
        const response = await this.getPackageInstanceCardsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get package instance invoices related to a client
     */
    async getPackageInstanceClientInvoicesRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getPackageInstanceClientInvoices.');
        }
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling getPackageInstanceClientInvoices.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling getPackageInstanceClientInvoices.');
        }
        const queryParameters = {};
        if (requestParameters.invoiceStatus !== undefined) {
            queryParameters['invoiceStatus'] = requestParameters.invoiceStatus;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/clients/{clientId}/package-instances/{packageInstanceId}/invoices`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.InvoiceFromJSON));
    }
    /**
     * Get package instance invoices related to a client
     */
    async getPackageInstanceClientInvoices(requestParameters, initOverrides) {
        const response = await this.getPackageInstanceClientInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get package instance current invoice
     */
    async getPackageInstanceCurrentInvoiceRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getPackageInstanceCurrentInvoice.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling getPackageInstanceCurrentInvoice.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/package-instances/{packageInstanceId}/current-invoice`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GetPackageInstanceCurrentInvoice200ResponseFromJSON)(jsonValue));
    }
    /**
     * Get package instance current invoice
     */
    async getPackageInstanceCurrentInvoice(requestParameters, initOverrides) {
        const response = await this.getPackageInstanceCurrentInvoiceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get package instance invoices related
     */
    async getPackageInstanceInvoicesRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getPackageInstanceInvoices.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling getPackageInstanceInvoices.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/package-instances/{packageInstanceId}/invoices`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.InvoiceFromJSON));
    }
    /**
     * Get package instance invoices related
     */
    async getPackageInstanceInvoices(requestParameters, initOverrides) {
        const response = await this.getPackageInstanceInvoicesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get package instance public data
     */
    async getPackageInstancePublicDataRaw(requestParameters, initOverrides) {
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling getPackageInstancePublicData.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling getPackageInstancePublicData.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/package-instances/{packageInstanceId}/public`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.PackageInstancePublicFromJSON)(jsonValue));
    }
    /**
     * Get package instance public data
     */
    async getPackageInstancePublicData(requestParameters, initOverrides) {
        const response = await this.getPackageInstancePublicDataRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Handle package instance status tracking
     */
    async packageInstanceTrackingRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling packageInstanceTracking.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling packageInstanceTracking.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling packageInstanceTracking.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/on-track/{packageInstanceId}`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.PackageInstanceTrackingRequestToJSON)(requestParameters.packageInstanceTrackingRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Handle package instance status tracking
     */
    async packageInstanceTracking(requestParameters, initOverrides) {
        const response = await this.packageInstanceTrackingRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Pause package instance
     */
    async pausePackageInstanceRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling pausePackageInstance.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling pausePackageInstance.');
        }
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling pausePackageInstance.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling pausePackageInstance.');
        }
        const queryParameters = {};
        if (requestParameters.silent !== undefined) {
            queryParameters['silent'] = requestParameters.silent;
        }
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/clients/{clientId}/package-instances/{packageInstanceId}/pause`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Pause package instance
     */
    async pausePackageInstance(requestParameters, initOverrides) {
        const response = await this.pausePackageInstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Resume package instance
     */
    async resumePackageInstanceRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling resumePackageInstance.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling resumePackageInstance.');
        }
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling resumePackageInstance.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling resumePackageInstance.');
        }
        if (requestParameters.resumePackageInstanceRequest === null || requestParameters.resumePackageInstanceRequest === undefined) {
            throw new runtime.RequiredError('resumePackageInstanceRequest', 'Required parameter requestParameters.resumePackageInstanceRequest was null or undefined when calling resumePackageInstance.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/clients/{clientId}/package-instances/{packageInstanceId}/resume`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.ResumePackageInstanceRequestToJSON)(requestParameters.resumePackageInstanceRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Resume package instance
     */
    async resumePackageInstance(requestParameters, initOverrides) {
        const response = await this.resumePackageInstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Return a boolean field indicating if the current package cycle should be blocked
     * Check if the package cycle should be blocked
     */
    async shouldBlockPackageRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling shouldBlockPackage.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling shouldBlockPackage.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling shouldBlockPackage.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/package-instances/{packageInstanceId}/should-block`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.ShouldBlockPackage200ResponseFromJSON)(jsonValue));
    }
    /**
     * Return a boolean field indicating if the current package cycle should be blocked
     * Check if the package cycle should be blocked
     */
    async shouldBlockPackage(requestParameters, initOverrides) {
        const response = await this.shouldBlockPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update package instance details
     */
    async updatePackageInstanceDetailsRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling updatePackageInstanceDetails.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updatePackageInstanceDetails.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling updatePackageInstanceDetails.');
        }
        if (requestParameters.updatePackageInstanceDetailsRequest === null || requestParameters.updatePackageInstanceDetailsRequest === undefined) {
            throw new runtime.RequiredError('updatePackageInstanceDetailsRequest', 'Required parameter requestParameters.updatePackageInstanceDetailsRequest was null or undefined when calling updatePackageInstanceDetails.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/package-instances/{packageInstanceId}/update-details`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.UpdatePackageInstanceDetailsRequestToJSON)(requestParameters.updatePackageInstanceDetailsRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Update package instance details
     */
    async updatePackageInstanceDetails(requestParameters, initOverrides) {
        const response = await this.updatePackageInstanceDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Updates the package instance frequency/duration
     */
    async updatePackageInstanceDurationRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling updatePackageInstanceDuration.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updatePackageInstanceDuration.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling updatePackageInstanceDuration.');
        }
        if (requestParameters.updatePackageInstanceDurationRequest === null || requestParameters.updatePackageInstanceDurationRequest === undefined) {
            throw new runtime.RequiredError('updatePackageInstanceDurationRequest', 'Required parameter requestParameters.updatePackageInstanceDurationRequest was null or undefined when calling updatePackageInstanceDuration.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/package-instances/{packageInstanceId}/update-duration`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.UpdatePackageInstanceDurationRequestToJSON)(requestParameters.updatePackageInstanceDurationRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Updates the package instance frequency/duration
     */
    async updatePackageInstanceDuration(requestParameters, initOverrides) {
        const response = await this.updatePackageInstanceDurationRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Updates the expiration date from a package instance
     */
    async updatePackageInstanceExpirationDateRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling updatePackageInstanceExpirationDate.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updatePackageInstanceExpirationDate.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling updatePackageInstanceExpirationDate.');
        }
        if (requestParameters.updatePackageInstanceExpirationDateRequest === null || requestParameters.updatePackageInstanceExpirationDateRequest === undefined) {
            throw new runtime.RequiredError('updatePackageInstanceExpirationDateRequest', 'Required parameter requestParameters.updatePackageInstanceExpirationDateRequest was null or undefined when calling updatePackageInstanceExpirationDate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/package-instances/{packageInstanceId}/update-expiration-date`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.UpdatePackageInstanceExpirationDateRequestToJSON)(requestParameters.updatePackageInstanceExpirationDateRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Updates the expiration date from a package instance
     */
    async updatePackageInstanceExpirationDate(requestParameters, initOverrides) {
        const response = await this.updatePackageInstanceExpirationDateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Lock or unlock package instance
     */
    async updatePackageInstanceLockedStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling updatePackageInstanceLockedStatus.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updatePackageInstanceLockedStatus.');
        }
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling updatePackageInstanceLockedStatus.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling updatePackageInstanceLockedStatus.');
        }
        if (requestParameters.updatePackageInstanceLockedStatusRequest === null || requestParameters.updatePackageInstanceLockedStatusRequest === undefined) {
            throw new runtime.RequiredError('updatePackageInstanceLockedStatusRequest', 'Required parameter requestParameters.updatePackageInstanceLockedStatusRequest was null or undefined when calling updatePackageInstanceLockedStatus.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/clients/{clientId}/package-instances/{packageInstanceId}/update-package-instance-locked-status`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.UpdatePackageInstanceLockedStatusRequestToJSON)(requestParameters.updatePackageInstanceLockedStatusRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Lock or unlock package instance
     */
    async updatePackageInstanceLockedStatus(requestParameters, initOverrides) {
        const response = await this.updatePackageInstanceLockedStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Updates the next cycle start date from a package instance
     */
    async updatePackageInstanceNextCycleStartDateRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling updatePackageInstanceNextCycleStartDate.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updatePackageInstanceNextCycleStartDate.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling updatePackageInstanceNextCycleStartDate.');
        }
        if (requestParameters.updatePackageInstanceStartDateRequest === null || requestParameters.updatePackageInstanceStartDateRequest === undefined) {
            throw new runtime.RequiredError('updatePackageInstanceStartDateRequest', 'Required parameter requestParameters.updatePackageInstanceStartDateRequest was null or undefined when calling updatePackageInstanceNextCycleStartDate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/package-instances/{packageInstanceId}/update-next-cycle-start-date`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.UpdatePackageInstanceStartDateRequestToJSON)(requestParameters.updatePackageInstanceStartDateRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Updates the next cycle start date from a package instance
     */
    async updatePackageInstanceNextCycleStartDate(requestParameters, initOverrides) {
        const response = await this.updatePackageInstanceNextCycleStartDateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update package instance payment option before complete the payment
     */
    async updatePackageInstancePaymentOptionRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling updatePackageInstancePaymentOption.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updatePackageInstancePaymentOption.');
        }
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling updatePackageInstancePaymentOption.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling updatePackageInstancePaymentOption.');
        }
        if (requestParameters.updatePackageInstancePaymentOptionRequest === null || requestParameters.updatePackageInstancePaymentOptionRequest === undefined) {
            throw new runtime.RequiredError('updatePackageInstancePaymentOptionRequest', 'Required parameter requestParameters.updatePackageInstancePaymentOptionRequest was null or undefined when calling updatePackageInstancePaymentOption.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/clients/{clientId}/package-instances/{packageInstanceId}/update-payment-option`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.UpdatePackageInstancePaymentOptionRequestToJSON)(requestParameters.updatePackageInstancePaymentOptionRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Update package instance payment option before complete the payment
     */
    async updatePackageInstancePaymentOption(requestParameters, initOverrides) {
        const response = await this.updatePackageInstancePaymentOptionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update package instance setup intent
     */
    async updatePackageInstanceSetupIntentRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling updatePackageInstanceSetupIntent.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updatePackageInstanceSetupIntent.');
        }
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling updatePackageInstanceSetupIntent.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling updatePackageInstanceSetupIntent.');
        }
        if (requestParameters.updatePackageInstanceSetupIntentRequest === null || requestParameters.updatePackageInstanceSetupIntentRequest === undefined) {
            throw new runtime.RequiredError('updatePackageInstanceSetupIntentRequest', 'Required parameter requestParameters.updatePackageInstanceSetupIntentRequest was null or undefined when calling updatePackageInstanceSetupIntent.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/clients/{clientId}/package-instances/{packageInstanceId}/update-setup-intent`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.UpdatePackageInstanceSetupIntentRequestToJSON)(requestParameters.updatePackageInstanceSetupIntentRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Update package instance setup intent
     */
    async updatePackageInstanceSetupIntent(requestParameters, initOverrides) {
        const response = await this.updatePackageInstanceSetupIntentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Updates the start date from a package instance
     */
    async updatePackageInstanceStartDateRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling updatePackageInstanceStartDate.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updatePackageInstanceStartDate.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling updatePackageInstanceStartDate.');
        }
        if (requestParameters.updatePackageInstanceStartDateRequest === null || requestParameters.updatePackageInstanceStartDateRequest === undefined) {
            throw new runtime.RequiredError('updatePackageInstanceStartDateRequest', 'Required parameter requestParameters.updatePackageInstanceStartDateRequest was null or undefined when calling updatePackageInstanceStartDate.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/package-instances/{packageInstanceId}/update-start-date`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.UpdatePackageInstanceStartDateRequestToJSON)(requestParameters.updatePackageInstanceStartDateRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Updates the start date from a package instance
     */
    async updatePackageInstanceStartDate(requestParameters, initOverrides) {
        const response = await this.updatePackageInstanceStartDateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update package instance tier before complete the payment
     */
    async updatePackageInstanceTierRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling updatePackageInstanceTier.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updatePackageInstanceTier.');
        }
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling updatePackageInstanceTier.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling updatePackageInstanceTier.');
        }
        if (requestParameters.updatePackageInstanceTierRequest === null || requestParameters.updatePackageInstanceTierRequest === undefined) {
            throw new runtime.RequiredError('updatePackageInstanceTierRequest', 'Required parameter requestParameters.updatePackageInstanceTierRequest was null or undefined when calling updatePackageInstanceTier.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/clients/{clientId}/package-instances/{packageInstanceId}/update-tier`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.UpdatePackageInstanceTierRequestToJSON)(requestParameters.updatePackageInstanceTierRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Update package instance tier before complete the payment
     */
    async updatePackageInstanceTier(requestParameters, initOverrides) {
        const response = await this.updatePackageInstanceTierRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update package instance usage pricing
     */
    async updateUsagePricingRaw(requestParameters, initOverrides) {
        if (requestParameters.xRequestId === null || requestParameters.xRequestId === undefined) {
            throw new runtime.RequiredError('xRequestId', 'Required parameter requestParameters.xRequestId was null or undefined when calling updateUsagePricing.');
        }
        if (requestParameters.organizationId === null || requestParameters.organizationId === undefined) {
            throw new runtime.RequiredError('organizationId', 'Required parameter requestParameters.organizationId was null or undefined when calling updateUsagePricing.');
        }
        if (requestParameters.clientId === null || requestParameters.clientId === undefined) {
            throw new runtime.RequiredError('clientId', 'Required parameter requestParameters.clientId was null or undefined when calling updateUsagePricing.');
        }
        if (requestParameters.packageInstanceId === null || requestParameters.packageInstanceId === undefined) {
            throw new runtime.RequiredError('packageInstanceId', 'Required parameter requestParameters.packageInstanceId was null or undefined when calling updateUsagePricing.');
        }
        if (requestParameters.updateUsagePricingRequest === null || requestParameters.updateUsagePricingRequest === undefined) {
            throw new runtime.RequiredError('updateUsagePricingRequest', 'Required parameter requestParameters.updateUsagePricingRequest was null or undefined when calling updateUsagePricing.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (requestParameters.xRequestId !== undefined && requestParameters.xRequestId !== null) {
            headerParameters['X-Request-Id'] = String(requestParameters.xRequestId);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/organizations/{organizationId}/clients/{clientId}/package-instances/{packageInstanceId}/update-usage-pricing`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters.organizationId))).replace(`{${"clientId"}}`, encodeURIComponent(String(requestParameters.clientId))).replace(`{${"packageInstanceId"}}`, encodeURIComponent(String(requestParameters.packageInstanceId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: (0, models_1.UpdateUsagePricingRequestToJSON)(requestParameters.updateUsagePricingRequest),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.GenericResponseFromJSON)(jsonValue));
    }
    /**
     * Update package instance usage pricing
     */
    async updateUsagePricing(requestParameters, initOverrides) {
        const response = await this.updateUsagePricingRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.PackageInstanceApi = PackageInstanceApi;
/**
  * @export
  * @enum {string}
  */
var GetPackageInstanceClientInvoicesInvoiceStatusEnum;
(function (GetPackageInstanceClientInvoicesInvoiceStatusEnum) {
    GetPackageInstanceClientInvoicesInvoiceStatusEnum["Shared"] = "shared";
    GetPackageInstanceClientInvoicesInvoiceStatusEnum["Failed"] = "failed";
    GetPackageInstanceClientInvoicesInvoiceStatusEnum["Paid"] = "paid";
    GetPackageInstanceClientInvoicesInvoiceStatusEnum["Scheduled"] = "scheduled";
    GetPackageInstanceClientInvoicesInvoiceStatusEnum["Draft"] = "draft";
    GetPackageInstanceClientInvoicesInvoiceStatusEnum["Open"] = "open";
})(GetPackageInstanceClientInvoicesInvoiceStatusEnum || (exports.GetPackageInstanceClientInvoicesInvoiceStatusEnum = GetPackageInstanceClientInvoicesInvoiceStatusEnum = {}));
//# sourceMappingURL=PackageInstanceApi.js.map